export const FETCH_CONTENT_REQUEST = `FETCH_CONTENT_REQUEST`;
export const FETCH_CONTENT_SUCCESS = `FETCH_CONTENT_SUCCESS`;
export const FETCH_CONTENT_ERROR = `FETCH_CONTENT_ERROR`;
